import React, {useState} from 'react';
import {
    AiOutlineDashboard, AiOutlineMobile, AiOutlineUser, AiOutlineShoppingCart,
    AiOutlineCustomerService, AiOutlineFileDone, AiOutlineCreditCard,
    AiOutlineCalculator, AiOutlineQrcode, AiOutlineDollarCircle, AiOutlineMergeCells, AiOutlineSafetyCertificate
} from 'react-icons/ai';
import { GrUserManager } from "react-icons/gr";
import {HiOutlineReceiptTax} from 'react-icons/hi';
import {BiPackage} from 'react-icons/bi';
import {useDispatch, useSelector} from 'react-redux';
import {openScreen, closeCurrentScreen} from '../../actions/uiActions';

const menuItems = [
    {id: 'uiOpenDashboard', label: 'Inicio', icon: AiOutlineDashboard},
    {id: 'uiOpenListDevice', label: 'Dispositivos', icon: AiOutlineMobile},
    {
        label: 'Usuarios', icon: AiOutlineUser, children: [
            {id: 'uiOpenListUser', label: 'Listar Usuarios'},
            {id: 'uiOpenListUserGroup', label: 'Grupos de Usuarios'},
        ]
    },
    {
        label: 'Deliverys', icon: AiOutlineShoppingCart, children: [
            {id: 'uiOpenListDelivery', label: 'Lista de Puntos de Entrega'},
            {id: 'uiOpenListDeliveryRouteGroup', label: 'Ruta de Puntos de Entrega'}
        ]
    },
    {
        label: 'Clientes', icon: AiOutlineCustomerService, children: [
            {id: 'uiOpenListCustomer', label: 'Listar Clientes'},
            {id: 'uiOpenListCustomerGroup', label: 'Grupos de Clientes'}
        ]
    },
    {id: 'uiOpenListDocument', label: 'Documentos', icon: AiOutlineFileDone},
    {
        label: 'Rango NCF', icon: HiOutlineReceiptTax, children: [
            {id: 'uiOpenListNCFRange', label: 'Listar Rangos NCF'},
            {id: 'uiOpenListNCFRangeGroup', label: 'Grupos de Rangos NCF'}
        ]
    },
    {
        label: 'Métodos de Pago', icon: AiOutlineCreditCard, children: [
            {id: 'uiOpenListPaymentMethod', label: 'Listar Métodos de Pago'},
            {id: 'uiOpenListPaymentMethodGroup', label: 'Grupos de Métodos'}
        ]
    },
    {id: 'uiOpenListDiscount', label: 'Descuentos', icon: AiOutlineCalculator},
    {
        label: 'Productos', icon: AiOutlineQrcode, children: [
            {id: 'uiOpenListProduct', label: 'Listar Productos'},
            {id: 'uiOpenListProductGroup', label: 'Grupos de Productos'}
        ]
    },
    {id: 'uiOpenListPrice', label: 'Precios', icon: AiOutlineDollarCircle},
    {
        label: 'Impuestos', icon: AiOutlineCalculator, children: [
            {id: 'uiOpenListTax', label: 'Listar Impuestos'},
            {id: 'uiOpenListTaxValue', label: 'Listar Valores de Imp.'},
            {id: 'uiOpenListTaxProduct', label: 'Prod. e Imp. Asociados'}
        ]
    },
    {
        label: 'Manejadores de Producto', icon: GrUserManager, children: [
            {id: 'uiOpenListProductHandlers', label: 'Listar de Manejadores Producto'},
            {id: 'uiOpenListProductHandlersGroup', label: 'Grupos de Manejadores Producto'}
        ]
    },
    {id: 'uiOpenListDgiiCert', label: 'Certificado DGII', icon: AiOutlineSafetyCertificate},
    {
        label: 'Almacenes', icon: BiPackage, children: [
            {id: 'uiOpenListWarehouse', label: 'Lista de Almacenes'},
            {id: 'uiOpenListWarehouseGroup', label: 'Almacenes Asociados'}
        ]
    },
    {id: 'uiOpenListMeasurementUnit', label: 'Unidades de medida', icon: AiOutlineMergeCells}
];

export const Sidebar = () => {
    const dispatch = useDispatch();
    const sidebarCollapsed = useSelector(state => state.ui.sidebar);
    const currentScreen = useSelector(state => state.ui.openScreen);
    const [openSubMenus, setOpenSubMenus] = useState({});

    const toggleSubMenu = (label) => {
        setOpenSubMenus(prev => ({...prev, [label]: !prev[label]}));
    };

    const handleClick = (e, id) => {
        e.stopPropagation();
        dispatch(closeCurrentScreen());
        dispatch(openScreen(id));
    };

    return (
        <nav
            className={[
                'bg-white border-r fixed left-0 top-0 h-screen z-40',
                sidebarCollapsed ? 'w-[60px]' : 'w-[240px]',
                // 👇 clave para el scroll
                'overflow-y-auto overflow-x-hidden',
                // opcional: mejor tacto en iOS
                'scroll-py-2',
                'transition-all duration-300'
            ].join(' ')}
            aria-label="Sidebar principal"
        >
            {/* padding top/bottom para que no se corte el último elemento */}
            <ul className="pt-4 pb-6 space-y-1 pr-1">
                {menuItems.map((item, idx) => (
                    <li key={idx}>
                        {!item.children ? (
                            <button
                                className={`w-full flex items-center gap-3 px-4 py-2 hover:bg-gray-100 transition text-sm ${currentScreen === item.id ? 'bg-gray-200 font-semibold' : ''}`}
                                onClick={(e) => handleClick(e, item.id)}
                            >
                                <item.icon size={20}/>
                                {!sidebarCollapsed && <span>{item.label}</span>}
                            </button>
                        ) : (
                            <>
                                <div
                                    className="flex items-center gap-3 px-4 py-2 cursor-pointer hover:bg-gray-100 text-sm"
                                    onClick={() => toggleSubMenu(item.label)}
                                    aria-expanded={!!openSubMenus[item.label]}
                                    aria-controls={`submenu-${idx}`}
                                    role="button"
                                >
                                    <item.icon size={20}/>
                                    {!sidebarCollapsed && (
                                        <>
                                            <span>{item.label}</span>
                                            <span className="ml-auto">{openSubMenus[item.label] ? '▼' : '▶'}</span>
                                        </>
                                    )}
                                </div>
                                {!sidebarCollapsed && openSubMenus[item.label] && (
                                    <ul id={`submenu-${idx}`} className="pl-10 space-y-1 transition-all duration-200">
                                        {item.children.map((child, i) => (
                                            <li key={i}>
                                                <button
                                                    className={`w-full text-left px-2 py-1 text-sm hover:bg-gray-100 transition ${currentScreen === child.id ? 'bg-gray-200 font-semibold' : ''}`}
                                                    onClick={(e) => handleClick(e, child.id)}
                                                >
                                                    {child.label}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    );
};